import {React, useState} from "react";

const YearCard = ({ yearData }) => {

  return (
    <div className="card card-year-summary">
      <h1>{yearData.year}</h1>
      <div className="container-stat">
        <h5 className="stat-label">You Sent</h5>
        <h1 className="stat text-yellow">{(parseInt(yearData.dm_sent) + parseInt(yearData.gm_sent)).toLocaleString('en')}</h1>
      </div>
      <div className="container-stat">
        <h5 className="stat-label">I Sent</h5>
        <h1 className="stat text-cyan">{(parseInt(yearData.dm_received) + parseInt(yearData.gm_received)).toLocaleString('en')}</h1>
      </div>
    </div>
  )

}

const YearlySummary = ({ summaryData }) => {

  const [curYear, setCurYear] = useState(0)

  return (
    <div className="container-yearly-summary">

      <div className="container-pill">
        <div className="pill">Intro</div>
        {summaryData.map((yearData, i) => {
          return (
            <div className={i === curYear ? "pill selected" : "pill"} onClick={() => setCurYear(i)}>{yearData.year}</div>
          )
        })}
        <div className="pill">Summary</div>
      </div>

      <YearCard yearData={summaryData[curYear]}/>




    </div>
  );
};

export default YearlySummary;
